export default "__VITE_ASSET__BPTcPPOx__"